import React, { useEffect, useState } from "react";
import capitalize from "lodash/capitalize";
import submit from "submit-form";
import Modal from "../modal-new";

const TutorialDetail = ({ selectedTutorial }) => {
  const { name, description, product, thumbnail_url } = selectedTutorial;

  const closeModal = () => {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "",
        selectedTutorial: "",
      },
    });
  };

  useEffect(() => {
    if (selectedTutorial) return;
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "",
        selectedTutorial: "",
      },
    });
  }, [selectedTutorial]);

  return (
    <Modal
      title={"MyStrengthBook University"}
      width="641px"
      canClose={true}
      onClose={closeModal}
      className={"msb-univ-modal"}
    >
      <div className="body">
        <div
          className="video"
          style={
            !selectedTutorial.video_html
              ? {
                  backgroundImage: `url(${thumbnail_url})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }
              : null
          }
          dangerouslySetInnerHTML={{
            __html: selectedTutorial.video_html.replace(/(&lt;([^>]+)>)/gi, ""),
          }}
        ></div>
      </div>
      <footer>
        <p className="s1">{name}</p>
        <p className="p4 pt-2 opacity-70">{description}</p>
      </footer>
    </Modal>
  );
};

export default TutorialDetail;
